import { MasterDataProvider } from './context/MasterDataContext';
import { MasterDataLayout } from './components/MasterDataLayout';

export const MasterData = () => {
    return (
        <MasterDataProvider>
            <MasterDataLayout />
        </MasterDataProvider>
    );
};
